import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import Interaction from '../../models/interactions/Interaction';
import InteractionNode from '../../models/interactions/InteractionNode';
import Tooltip from '@mui/material/Tooltip';
import CommunicationSet from '../../models/communications/CommunicationSet';
import IntervalSet from '../../models/communications/IntervalSet';
import Interval from '../../models/communications/Interval';

interface CommitCheckboxProps {
    interaction?: Interaction | undefined;
    interactionNode?: InteractionNode | undefined;
    communication_set?: CommunicationSet |undefined;
    interval_set?: IntervalSet |undefined;
    interval?: Interval |undefined;
    handleCheck?:any
}

const CommitCheckbox = (props:CommitCheckboxProps) => {
  const [checked, setChecked] = React.useState(true);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    if(props.interaction){
        props.handleCheck(props.interaction.id,event.target.checked, "interaction");
    } else if (props.communication_set){
        props.handleCheck(props.communication_set.id,event.target.checked, "communication_set");
    } else if (props.interval_set){
        props.handleCheck(props.interval_set.id,event.target.checked, "interval_set");
    } else if (props.interval){
        props.handleCheck(props.interval.id,event.target.checked, "interval");
    }
  };

  const tooltip = "Commit entity " + (props.interaction?.id || props.communication_set?.id || props.interval_set?.id || props.interval?.id)
  const key  = props.interaction?.id || props.communication_set?.id || props.interval_set?.id || props.interval?.id;
  return (
    <Tooltip title={tooltip}>
        <Checkbox
            key={key}
            checked={checked}
            style={{padding:"0px", margin:"0px"}}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'controlled' }}
        />
    </Tooltip>
  );
}

export default CommitCheckbox
